import axios from 'axios'

const TOKEN_KEY = 'monitoring.token'

/**
 * Token drzime v localStorage, ne v pameti: verejne status stranky se casto
 * otevrou v novem tabu a prihlaseny uzivatel by se jinak musel v kazdem
 * novem tabu prihlasovat znovu.
 */
export const tokenStorage = {
  get: (): string | null => localStorage.getItem(TOKEN_KEY),
  set: (token: string) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
}

/** Chranene API — /api/app/*. Token pripojuje interceptor nize. */
export const api = axios.create({ baseURL: '/api/app' })

/** Verejne API — /api/public/*. Zamerne bez tokenu, i kdyz nejaky mame. */
export const publicApi = axios.create({ baseURL: '/api/public' })

api.interceptors.request.use((config) => {
  const token = tokenStorage.get()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

/**
 * Expirovany nebo zneplatneny token: zahodime ho a posleme uzivatele na
 * prihlaseni. Tvrdy redirect (ne router.navigate) je tu zamerne — vyhodi
 * i rozpracovany stav TanStack Query, ktery uz stejne patri nekomu jinemu.
 */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      tokenStorage.clear()
      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  },
)

/** Hlaska z backendu (ErrorResponse.message), jinak predana nahrada. */
export function errorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const message = (err.response?.data as { message?: string } | undefined)?.message
    if (message) return message
  }
  return fallback
}
